export const useApi = () => {
  const errMsg = (err: any): string => {
    return !!err.data ? err.data.message : err.message;
  };
  const maxCounter = (str: string, max: number): string =>
    !!str ? `${str.length}/${max}` : `0/${max}`;
  return { errMsg, maxCounter };
};
